import { Capacitor } from '@capacitor/core';
import { Purchases } from '@revenuecat/purchases-capacitor';
import axios, { isNative } from './api';

let configurationPromise;

async function configurePurchases(apiKey, appUserID) {
  if (!configurationPromise) {
    configurationPromise = (async () => {
      const { isConfigured } = await Purchases.isConfigured();
      if (!isConfigured) await Purchases.configure({ apiKey, appUserID });
    })().catch(error => {
      configurationPromise = null;
      throw error;
    });
  }
  await configurationPromise;
  const currentUser = await Purchases.getAppUserID();
  if (currentUser.appUserID !== appUserID) await Purchases.logIn({ appUserID });
}

export async function loadBilling() {
  const platform = isNative ? Capacitor.getPlatform() : 'web';
  const response = await axios.get(`/api/billing/config?platform=${platform}`);
  const { balance, apiKey, appUserID, packs } = response.data;
  if (!isNative || !apiKey) return { balance, packages: [], purchasesAvailable: false };

  await configurePurchases(apiKey, appUserID);
  const offerings = await Purchases.getOfferings();
  const packages = (offerings.current?.availablePackages || [])
    .filter(item => packs[item.product.identifier])
    .sort((a, b) => packs[a.product.identifier] - packs[b.product.identifier]);
  return { balance, packages, purchasesAvailable: packages.length > 0, packs };
}

export async function refreshBalance() {
  const response = await axios.get('/api/billing/balance');
  return response.data.balance;
}

export async function purchaseCreditPackage(aPackage) {
  return Purchases.purchasePackage({ aPackage });
}

export async function restorePurchases() {
  return Purchases.restorePurchases();
}
